export enum AdminScopeType {
  Super = 'super',
  Tenant = 'tenant',
}

export enum AdminPathSegment {
  Auth = 'auth',
  Super = 'super',
  Admin = 'admin',
  Login = 'login',
}

export type AdminScope =
  | { type: AdminScopeType.Super }
  | { type: AdminScopeType.Tenant; tenantSlug: string }
